'use strict';

const disassembleISODatePartToParts = (isoDatePart) => {
  const parts = isoDatePart.split("-").map(Number);
  return {
    year: parts[0],
    month: parts[1],
    day: parts[2]
  };
};

module.exports = disassembleISODatePartToParts;
//# sourceMappingURL=disassembleISODatePartToParts.cjs.map
